import { initKeycloak } from "./authorization/keycloak/keycloak";
import { parmAutoProvision, parmUserPermissions } from "./authorization/parm/parm";
import { initSingleSpa } from "./singleSpa";
import { createKeycloakInterface } from "./authorization/authorizationInterface";
import { createSmartAuthInterface, getSmartSessionId } from "./authorization/smart/smart";
import { setAuthorizationInterface } from "./static/authorization";
import { mark, measure } from "./helpers/perf";
import { ParmConstants } from "./types/parm";

export const startApp = async () => {
  console.log(`GUAC-CORE VERSION: ${process.env.npm_package_version}`); //eslint-disable-line
  mark("start");

  const sessionId = getSmartSessionId();
  let authInterface = null;

  if (sessionId) {
    authInterface = await createSmartAuthInterface(sessionId);
  } else {
    const keycloak = await initKeycloak();
    authInterface = createKeycloakInterface(keycloak);
  }

  setAuthorizationInterface(authInterface);
  mark("auth-end");
  measure("auth", "start", "auth-end");

  await parmAutoProvision();
  mark("auto-provision-end");
  measure("parm-auto-provision", "auth-end", "auto-provision-end");

  // Runs in parallel with DRS and shared dependencies; non-layout modules wait for it before loading.
  const permissionsReady = parmUserPermissions().finally(() => {
    mark("permissions-end");
    measure("parm-permissions", "auto-provision-end", "permissions-end");
  });

  if (window.location.pathname === "/logout") {
    window.history.pushState({}, "", "/");
    authInterface.logout();
    return;
  }

  await initSingleSpa(permissionsReady);
  mark("shell-ready");
  measure("bootstrap", "start", "shell-ready");
};
